import PostPopup from "components/Organismos/PostPopup";
import L from 'leaflet';
import { GeoJsonEssentialServiceProperties } from "models/essential-services.model";
import { GeoJsonInformativeProperties } from "models/informatives.model";
import { FeatureGroup, Marker, Popup } from "react-leaflet";
import informativePin from '_assets/imgs/mapa/map-icon-green.png';
import essentialServicePin from '_assets/imgs/mapa/map-icon-orange.png';

import './styles.css';

type PostMapLayerProps = {
    postType: "Informativo" | "Ponto essencial";
    features: GeoJSON.Feature<GeoJSON.Point, GeoJsonEssentialServiceProperties | GeoJsonInformativeProperties>[];
    hideButtons?: boolean;
    onEditClick?: (properties: GeoJsonEssentialServiceProperties | GeoJsonInformativeProperties, geometry: GeoJSON.Point) => void;
}

const essentialServiceIcon = L.icon({
    iconUrl: essentialServicePin,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

const informativeIcon = L.icon({
    iconUrl: informativePin,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

const PostsMapLayer = ({
    features,
    postType,
    hideButtons,
    onEditClick
}: PostMapLayerProps) => {
    return (
        <FeatureGroup>
            {features.map(feat => (
                <Marker
                    key={`marker-${postType}-${feat.properties.Id}`}
                    icon={postType === "Informativo" ? informativeIcon : essentialServiceIcon}
                    position={[feat.geometry.coordinates[1], feat.geometry.coordinates[0]]}
                >
                    <Popup>
                        <PostPopup
                            title={feat.properties.Titulo}
                            header={postType}
                            address={feat.properties.Endereco.logradouro}
                            hideButtons={hideButtons}
                            onEditClick={() => onEditClick?.(feat.properties, feat.geometry)}
                        />
                    </Popup>
                </Marker>
            ))}
        </FeatureGroup>
    )
}
export default PostsMapLayer